import axios from "src/lib/axios";

export const UpdateTranslation = async (data: any): Promise<any> => {
    const response = await axios.post<any>(
        '/Translation/UpdateTranslation', data
    );
    return response?.data;
};

export const getTranslation = async (): Promise<any> => {
    const response = await axios.get<any[]>(
      '/Translation/GetTranslations'
    );
    return response?.data;
  };